import {useEffect, useState} from "react";

const PolygonWithEffects = ({ normalizedCoordinates, isActiveSlide, isMissingImage }: { normalizedCoordinates: { x: number; y: number }[], isActiveSlide:boolean, isMissingImage: boolean }) => {
  const [isInitiallyVisible, setIsInitiallyVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setIsInitiallyVisible(true);
    const timer = setTimeout(() => {
      setIsInitiallyVisible(false);
    }, 1000);
    return () => clearTimeout(timer);

  }, [isActiveSlide]);

  const isActive = isInitiallyVisible || isHovered;
  return (
    <polygon
      points={normalizedCoordinates.map(p => `${p.x},${p.y}`).join(' ')}
      className={`cursor-pointer polygon-transition ${isMissingImage && 'missing'} ${isActive ? 'active' : 'delayed-exit'}`}
      style={{
        pointerEvents: 'auto',
        strokeWidth: 5,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
};

export default PolygonWithEffects;
